/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Annual_Preselect_NoteInputs */

const en_pricing_annual_preselect_note = /** @type {(inputs: Pricing_Annual_Preselect_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annual billing selected -- best value`)
};

const de_pricing_annual_preselect_note = /** @type {(inputs: Pricing_Annual_Preselect_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jährliche Abrechnung ausgewählt -- bestes Preis-Leistungs-Verhältnis`)
};

const fr_pricing_annual_preselect_note = /** @type {(inputs: Pricing_Annual_Preselect_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturation annuelle sélectionnée -- meilleur rapport qualité-prix`)
};

const es_pricing_annual_preselect_note = /** @type {(inputs: Pricing_Annual_Preselect_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturación anual seleccionada -- mejor relación calidad-precio`)
};

const it_pricing_annual_preselect_note = /** @type {(inputs: Pricing_Annual_Preselect_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fatturazione annuale selezionata -- miglior rapporto qualità-prezzo`)
};

const nl_pricing_annual_preselect_note = /** @type {(inputs: Pricing_Annual_Preselect_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jaarlijkse facturering geselecteerd -- beste prijs-kwaliteitverhouding`)
};

const pl_pricing_annual_preselect_note = /** @type {(inputs: Pricing_Annual_Preselect_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybrano rozliczenie roczne -- najlepszy stosunek jakości do ceny`)
};

const fi_pricing_annual_preselect_note = /** @type {(inputs: Pricing_Annual_Preselect_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuosilaskutus valittu -- paras hinta-laatusuhde`)
};

const da_pricing_annual_preselect_note = /** @type {(inputs: Pricing_Annual_Preselect_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årlig fakturering valgt -- bedste pris-kvalitetsforhold`)
};

const sv_pricing_annual_preselect_note = /** @type {(inputs: Pricing_Annual_Preselect_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årlig fakturering vald -- bästa pris-kvalitetsförhållande`)
};

/**
* | output |
* | --- |
* | "Annual billing selected -- best value" |
*
* @param {Pricing_Annual_Preselect_NoteInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_annual_preselect_note = /** @type {((inputs?: Pricing_Annual_Preselect_NoteInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Annual_Preselect_NoteInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_annual_preselect_note(inputs)
	if (locale === "fr") return fr_pricing_annual_preselect_note(inputs)
	if (locale === "es") return es_pricing_annual_preselect_note(inputs)
	if (locale === "it") return it_pricing_annual_preselect_note(inputs)
	if (locale === "nl") return nl_pricing_annual_preselect_note(inputs)
	if (locale === "pl") return pl_pricing_annual_preselect_note(inputs)
	if (locale === "fi") return fi_pricing_annual_preselect_note(inputs)
	if (locale === "da") return da_pricing_annual_preselect_note(inputs)
	if (locale === "sv") return sv_pricing_annual_preselect_note(inputs)
	return en_pricing_annual_preselect_note(inputs)
});